// Render an ISO/UTC timestamp in the clinic timezone (ET) with a short tz label,
// so audit and feedback times are unambiguous regardless of the viewer's browser tz.
const CLINIC_TZ = "America/New_York";

export function formatClinicTimestamp(val) {
  if (!val) return "-";
  const d = new Date(val);
  if (isNaN(d.getTime())) return "-";
  return d.toLocaleString("en-US", {
    timeZone: CLINIC_TZ,
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZoneName: "short",
  });
}
